import { useCallback, useEffect, useState } from 'react';
import type { FilterLineType } from '../../../../components/new-design/vyTableFilter';
import { useDebounce } from '../../../../hooks/use-debounce';
import { useDialog } from '../../../../hooks/use-dialog';
import { usePageParam } from '../../../../hooks/search-params/use-page-param';
import { useSyncQueryParamToState } from '../../../../hooks/search-params/use-sync-query-param-to-state';
import { useQueryInputParams } from './use-query-input-param';
import { useFiltersParam } from './use-filters-param';

export const useCustomersFilters = () => {
  const [queryParam, setQueryParam] = useQueryInputParams();
  const [query, setQuery] = useState(queryParam ?? '');
  const debouncedQuery = useDebounce(query);
  const [filters, setFilters] = useFiltersParam();
  const [, setPage] = usePageParam();

  const {
    isDialogOpen: isFilterCustomersOpen,
    handleOpen: openFilterCustomers,
    handleClose: closeFilterCustomers,
  } = useDialog();

  useEffect(() => {
    setQueryParam(debouncedQuery);
  }, [debouncedQuery]);

  useSyncQueryParamToState(queryParam, setQuery);

  const handleSearchInputChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setQuery(event.target.value);
    },
    [],
  );

  const handleFilterClick = useCallback(
    (filterLines: FilterLineType[]) => {
      setFilters(filterLines);
      setPage(0);
    },
    [],
  );

  return {
    query,
    handleSearchInputChange,
    filters,
    handleFilterClick,
    isFilterCustomersOpen,
    openFilterCustomers,
    closeFilterCustomers,
  };
};
